import { useMediaQuery, useTheme } from '@mui/material';
import _, { property } from 'lodash';

export function useMicroCheck() {
    const theme = useTheme();
    return useMediaQuery(theme.breakpoints.only('xs'));
}

/**
 * @param {{ answers: { display_order: number }[] }} section
 * @returns {number[]}
 */
export const deriveDisplayOrder = section => _(section)
    .map((item, index) => ({
        index,
        displayOrder: item.answers[0].display_order,
    }))
    .sortBy(property('displayOrder'))
    .map(property('index'))
    .value();